import React from 'react';

import * as S from './style';

interface TitleProps {
    as?: 'h1' | 'h2' | 'h3' | 'h4';
    title: string;
    size?: string;
    isSubtitle?: boolean;
    centered?: boolean;
    margin?: number[];
}

const Title: React.FC<TitleProps> = ({ title, as, margin, isSubtitle, centered, size }) => (
    isSubtitle ? (
        <S.SubTitle 
            as={as} 
            size={size} 
            margin={margin} 
            centered={centered}
         
        >
            {title}
        </S.SubTitle>
    ) : (
        <S.Title 
            as={as} 
            size={size} 
            margin={margin} 
            centered={centered}
           
        >
            {title}
        </S.Title>
    )

);

export default Title;